import React, { useMemo, useContext } from 'react';

import CallOut from 'components/CallOut';
import { useCallOutQuery } from 'hooks/useCallOutQuery';
import useLiveData from 'hooks/useLiveData';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const CallOutProvider = ({ children, staticData, id, ...props }) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const { data } = useCallOutQuery();
	const shouldLimitLiveDataByStaticIds = !staticData;
	const effectiveStaticData = React.useMemo(() => staticData || data || {}, [staticData, data]);
	const callOutEdges = effectiveStaticData?.allCallOut?.edges || [];
	const callOutNodes = callOutEdges.map(({ node }) => node);

	const {
		statusText: callOutStatusText,
		response: callOutResponse,
		visibilityChange: callOutVisibilityChange,
	} = useLiveData({
		namespace: 'SmartTags',
		model: 'CallOut',
		method: 'all',
		graphqlKey: 'allSmartTagsCallOut',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_join: 'Audience',
			...(shouldLimitLiveDataByStaticIds && callOutNodes.length > 0 ? {
				id: callOutNodes.map((n) => n.id).join(','),
			} : {}),
			...(!!id ? { id } : {}),
		},
		staticData: effectiveStaticData,
	});

	const liveCallOut = callOutResponse?.data[0];
	let callOut = callOutNodes[0];
	if (!!liveCallOut && callOutStatusText === 'LOADED') {
		callOut = liveCallOut;
	}
	if (!!liveCallOut && callOutVisibilityChange) callOut = liveCallOut;

	const datum = useMemo(() => callOut, [callOut]);

	if (!!datum && datum.hasOwnProperty('Audience') && datum?.Audience) {
		if (!matchAudience(datum?.Audience)) {
			return null;
		}
	}

	return (
		<CallOut {...datum} matchAudience={matchAudience} />
	);
};

export default CallOutProvider;